// Determine if we're in development mode
const isDevelopment = process.env.NODE_ENV === 'development';

// Get the backend API base URL
const getApiBaseUrl = () => {
  return process.env.REACT_APP_API_BASE_URL || 'https://token-proxy-asd3etazf5a3h7fr.canadacentral-01.azurewebsites.net';
};

// All API calls now go through the backend server
const getDynamicsBaseUrl = () => {
  return `${getApiBaseUrl()}/api/dynamics`;
};

const getTokenApiUrl = () => {
  return `${getApiBaseUrl()}/api/token`;
};

export const API_CONFIG = {
  // Dynamics 365 Base URL (proxied in development)
  DYNAMICS_BASE_URL: getDynamicsBaseUrl(),

  // Token API URL (proxied in development)
  TOKEN_API_URL: getTokenApiUrl(),

  // Original URLs (for display/reference only)
  DYNAMICS_DIRECT_URL: process.env.REACT_APP_DYNAMICS_BASE_URL || 'https://shpdev01274a5a74e0a95c97devaos.cloudax.eu.dynamics.com',
  TOKEN_API_DIRECT_URL: process.env.REACT_APP_TOKEN_API_URL || 'https://token-proxy-asd3etazf5a3h7fr.canadacentral-01.azurewebsites.net/api/token',

  // Azure AD Configuration
  TENANT_ID: process.env.REACT_APP_TENANT_ID || '079f0f10-14a7-420a-9161-5233ef8aee2a',
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID || '8a74e3d6-dd8d-42c7-951e-c63d24a1d762',
  CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET || '3~G8Q~8UTz_eVdze8AqDK8NN_npikwOGnytjmcyR',
  GRANT_TYPE: process.env.REACT_APP_GRANT_TYPE || 'client_credentials',

  // Environment name
  ENV_NAME: process.env.REACT_APP_ENV_NAME || 'Development',

  // Development mode flag
  IS_DEVELOPMENT: isDevelopment,
  USE_PROXY: false, // No longer using proxy - all calls go through backend

  // Default query parameters
  DEFAULT_PARAMS: {
    CROSS_COMPANY: true,
  },
};

// Business Central API Configuration
export const BC_CONFIG = {
  tenantId: process.env.REACT_APP_BC_TENANT_ID || '079f0f10-14a7-420a-9161-5233ef8aee2a',
  environment: process.env.REACT_APP_BC_ENVIRONMENT || 'SHPSandboxQA',
  companyId: process.env.REACT_APP_BC_COMPANY_ID || 'f4b4f73d-82f0-4485-96b5-b0e8e8e6fa9b',
};

// Log current environment configuration
if (process.env.NODE_ENV === 'development') {
  // Determine environment color based on name
  const isDev = API_CONFIG.ENV_NAME.toLowerCase().includes('dev');
  const isProd = API_CONFIG.ENV_NAME.toLowerCase().includes('prod');
  const isUAT = API_CONFIG.ENV_NAME.toLowerCase().includes('uat');

  let bannerColor = '#1e40af'; // blue
  if (isDev) bannerColor = '#059669'; // green
  if (isProd) bannerColor = '#dc2626'; // red
  if (isUAT) bannerColor = '#f59e0b'; // yellow

  console.log('\n');
  console.log(
    '%c╔═══════════════════════════════════════════════════════════════╗',
    `color: ${bannerColor}; font-weight: bold;`
  );
  console.log(
    '%c║          🚀 APP STARTED - ' + API_CONFIG.ENV_NAME.toUpperCase() + ' ENVIRONMENT 🚀          ║',
    `color: ${bannerColor}; font-weight: bold;`
  );
  console.log(
    '%c╚═══════════════════════════════════════════════════════════════╝',
    `color: ${bannerColor}; font-weight: bold;`
  );
  console.log('\n');

  console.group('%c📋 Environment Details', 'font-size: 14px; font-weight: bold; color: #2563eb');
  console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #94a3b8');
  console.log('%c Environment Name:', 'font-weight: bold; color: #1e40af', API_CONFIG.ENV_NAME);
  console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #94a3b8');
  console.groupEnd();

  console.group('%c🔗 Connection URLs', 'font-size: 14px; font-weight: bold; color: #059669');
  console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #94a3b8');
  console.log('%c 🌐 Backend API Server', 'font-weight: bold; color: #10b981; background: #d1fae5; padding: 2px 6px; border-radius: 3px;');
  console.log('%c   Dynamics 365 API:', 'font-weight: bold; color: #059669', API_CONFIG.DYNAMICS_BASE_URL);
  console.log('%c   Token API:', 'font-weight: bold; color: #059669', API_CONFIG.TOKEN_API_URL);
  console.log('%c   Direct Dynamics URL:', 'font-weight: bold; color: #6366f1', API_CONFIG.DYNAMICS_DIRECT_URL);
  console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #94a3b8');
  console.groupEnd();

  console.group('%c🔑 Azure AD Credentials', 'font-size: 14px; font-weight: bold; color: #7c3aed');
  console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #94a3b8');
  console.log('%c Tenant ID:', 'font-weight: bold; color: #7c3aed', API_CONFIG.TENANT_ID);
  console.log('%c Client ID:', 'font-weight: bold; color: #ea580c', API_CONFIG.CLIENT_ID);
  console.log('%c Client Secret:', 'font-weight: bold; color: #64748b', API_CONFIG.CLIENT_SECRET.substring(0, 10) + '...' + API_CONFIG.CLIENT_SECRET.substring(API_CONFIG.CLIENT_SECRET.length - 4));
  console.log('%c Grant Type:', 'font-weight: bold; color: #0891b2', API_CONFIG.GRANT_TYPE);
  console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #94a3b8');
  console.groupEnd();

  console.group('%c⚙️ Configuration', 'font-size: 14px; font-weight: bold; color: #65a30d');
  console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #94a3b8');
  console.log('%c Cross-Company Queries:', 'font-weight: bold; color: #65a30d', API_CONFIG.DEFAULT_PARAMS.CROSS_COMPANY ? '✅ Enabled' : '❌ Disabled');
  console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #94a3b8');
  console.groupEnd();

  console.log('\n');
  console.log(
    '%c💡 TIP: Copy these IDs if you need to verify your environment',
    'background: #fef3c7; color: #92400e; padding: 6px 12px; border-radius: 4px; font-style: italic;'
  );
  console.log('\n');
}

// Helper function to display current environment in console
// Usage: Type 'showEnv()' in browser console
window.showEnv = function() {
  console.clear();
  console.log('\n');
  console.log(
    '%c╔═══════════════════════════════════════════════════════════════╗',
    'color: #059669; font-weight: bold; font-size: 12px;'
  );
  console.log(
    '%c║              CURRENT ENVIRONMENT CONFIGURATION                ║',
    'color: #059669; font-weight: bold; font-size: 12px;'
  );
  console.log(
    '%c╚═══════════════════════════════════════════════════════════════╝',
    'color: #059669; font-weight: bold; font-size: 12px;'
  );
  console.log('\n');

  console.log('%c📋 ENVIRONMENT', 'background: #1e40af; color: white; padding: 4px 8px; font-weight: bold; border-radius: 3px;');
  console.log('Name:', API_CONFIG.ENV_NAME);
  console.log('\n');

  console.log('%c🔗 API ENDPOINTS', 'background: #059669; color: white; padding: 4px 8px; font-weight: bold; border-radius: 3px;');
  console.log('Dynamics 365 API: ' + API_CONFIG.DYNAMICS_BASE_URL);
  console.log('Token API: ' + API_CONFIG.TOKEN_API_URL);
  console.log('Backend proxies to: ' + API_CONFIG.DYNAMICS_DIRECT_URL);
  console.log('\n');

  console.log('%c🔑 AZURE AD CREDENTIALS', 'background: #7c3aed; color: white; padding: 4px 8px; font-weight: bold; border-radius: 3px;');
  console.table({
    'Tenant ID': API_CONFIG.TENANT_ID,
    'Client ID': API_CONFIG.CLIENT_ID,
    'Client Secret': API_CONFIG.CLIENT_SECRET.substring(0, 15) + '...',
    'Grant Type': API_CONFIG.GRANT_TYPE,
  });
  console.log('\n');

  console.log('%c⚙️ SETTINGS', 'background: #65a30d; color: white; padding: 4px 8px; font-weight: bold; border-radius: 3px;');
  console.log('Cross-Company:', API_CONFIG.DEFAULT_PARAMS.CROSS_COMPANY ? '✅ Enabled' : '❌ Disabled');
  console.log('\n');

  console.log(
    '%c💡 You can run this command anytime by typing: showEnv()',
    'background: #fef3c7; color: #92400e; padding: 6px 12px; border-radius: 4px; font-style: italic;'
  );
  console.log('\n');

  return {
    environment: API_CONFIG.ENV_NAME,
    backendServer: process.env.REACT_APP_API_BASE_URL,
    dynamicsApiUrl: API_CONFIG.DYNAMICS_BASE_URL,
    tokenApiUrl: API_CONFIG.TOKEN_API_URL,
    dynamicsTarget: API_CONFIG.DYNAMICS_DIRECT_URL,
    tenantId: API_CONFIG.TENANT_ID,
    clientId: API_CONFIG.CLIENT_ID,
    grantType: API_CONFIG.GRANT_TYPE,
    crossCompany: API_CONFIG.DEFAULT_PARAMS.CROSS_COMPANY,
  };
};

// Show command hint
if (process.env.NODE_ENV === 'development') {
  console.log(
    '%c💡 Type showEnv() in console to see current environment anytime',
    'background: #dbeafe; color: #1e40af; padding: 6px 12px; border-radius: 4px; font-weight: bold; margin: 10px 0;'
  );
}

export default API_CONFIG;
